<template>
  <div class="building-owner-form mx-5">
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-radio-group
            v-model="newOwnerType"
            :options="departBuildingLotNewOwnerTypeOptions"
            @change="updateNewOwnerType"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="newOwnerType == departBuildingLotNewOwnerTypes.existing">
      <b-col>
        <label>Propriétaires existants</label>
        <ValidationProvider
          ref="vee-existing-b-owner"
          v-slot="{ errors, classes }"
          :name="'propriétaire existant'"
          rules="required"
        >
          <v-select
            label="name"
            :reduce="name => name.id"
            :options="buildingOwnersOptions"
            :value="existingBuildingOwnerId"
            @input="updateExistingBuildingOwnerId($event)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>

    <b-row v-if="newOwnerType == departBuildingLotNewOwnerTypes.new">
      <b-col>
        <!-- gender | lastname | firstname | email -->
        <b-row class="my-3 justify-content-center">
          <b-col cols="12">
            <b-row>
              <b-col cols="6">
                <b-button
                  class="btn-block"
                  squared
                  :class="{
                    'agv btn-primary': newBuildingOwner.entity_type == entityTypes.individual,
                    'agv btn-outline-primary':
                      newBuildingOwner.entity_type != entityTypes.individual,
                  }"
                  variant="none"
                  @click="setEntityType(entityTypes.individual)"
                >
                  <strong>Particulier</strong>
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-button
                  class="btn-block"
                  squared
                  variant="none"
                  :class="{
                    'agv btn-primary': newBuildingOwner.entity_type == entityTypes.legal,
                    'agv btn-outline-primary': newBuildingOwner.entity_type != entityTypes.legal,
                  }"
                  @click="setEntityType(entityTypes.legal)"
                >
                  <strong>Professionnel</strong>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mb-5 mb-sm-4 mx-sm-0">
          <b-col v-if="newBuildingOwner.entity_type == entityTypes.individual" sm="3" md="2">
            <label>{{ $t("general.Civilité") }}</label>
            <b-form-select
              :value="newBuildingOwner.gender"
              :options="genderOptions"
              @change="updateNewBuildingOwner('gender', $event)"
            />
          </b-col>
          <b-col v-if="newBuildingOwner.entity_type == entityTypes.individual" sm="4" md="3">
            <label>{{ $t("general.Nom") }}</label>
            <ValidationProvider
              ref="vee-b-owner-lastname"
              v-slot="{ errors, classes }"
              :name="'nom'"
              rules="required"
            >
              <b-input
                :value="newBuildingOwner.lastname"
                @input="updateNewBuildingOwner('lastname', $event)"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col v-if="newBuildingOwner.entity_type == entityTypes.individual" sm="4" md="3">
            <label>{{ $t("general.Prénom") }}</label>
            <b-input
              :value="newBuildingOwner.firstname"
              @input="updateNewBuildingOwner('firstname', $event)"
            />
          </b-col>

          <b-col v-if="newBuildingOwner.entity_type == entityTypes.legal" sm="7" md="6">
            <label>Raison sociale</label>
            <ValidationProvider
              ref="vee-b-owner-lastname"
              v-slot="{ errors, classes }"
              :name="'raison sociale'"
              rules="required"
            >
              <b-input
                :value="newBuildingOwner.lastname"
                @input="updateNewBuildingOwner('lastname', $event)"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>

          <b-col sm="6" md="4">
            <label>{{ $t("general.Email") }}</label>
            <ValidationProvider
              ref="vee-b-owner-email"
              v-slot="{ errors, classes }"
              :name="'email'"
              :rules="
                newBuildingOwner.contact_type == contactTypes.email ? 'required|email' : 'email'
              "
            >
              <b-input
                :value="newBuildingOwner.email"
                @input="updateNewBuildingOwner('email', $event)"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
        <!-- street nb | street | address second -->
        <b-row class="mb-5 mb-sm-4 mx-sm-0">
          <b-col sm="6" md="6">
            <label>Adresse</label>
            <ValidationProvider
              ref="vee-b-owner-address"
              v-slot="{ errors, classes }"
              :name="'adresse'"
              rules="required"
            >
              <b-input
                :value="newBuildingOwner.address"
                @input="updateNewBuildingOwner('address', $event)"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col sm="6" md="6">
            <label>{{ $t("general.Complément") }}</label>
            <b-input
              :value="newBuildingOwner.complement"
              @input="updateNewBuildingOwner('complement', $event)"
            />
          </b-col>
        </b-row>
        <!-- zipcode | city | country -->
        <b-row class="mb-5 mb-sm-4 mx-sm-0">
          <b-col sm="3" md="2">
            <label>{{ $t("general.Code_postal") }}</label>
            <ValidationProvider
              ref="vee-b-owner-zipcode"
              v-slot="{ errors, classes }"
              :name="'code postal'"
              rules="required"
            >
              <b-input
                :value="newBuildingOwner.zipcode"
                @input="updateNewBuildingOwner('zipcode', $event)"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col sm="4" md="3">
            <label>Ville</label>
            <ValidationProvider
              ref="vee-b-owner-city"
              v-slot="{ errors, classes }"
              :name="'ville'"
              rules="required"
            >
              <b-input
                :value="newBuildingOwner.city"
                @input="updateNewBuildingOwner('city', $event)"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col sm="4" md="3">
            <label>{{ $t("general.Pays") }}</label>
            <ValidationProvider
              ref="vee-b-owner-country"
              v-slot="{ errors, classes }"
              :name="'pays'"
              rules="required"
            >
              <b-form-select
                :value="newBuildingOwner.country"
                :options="countryOptions"
                @input="updateNewBuildingOwner('country', $event)"
              >
                <template #first>
                  <b-form-select-option :value="''" disabled>
                    Choisissez le pays
                  </b-form-select-option>
                </template>
              </b-form-select>
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>

          <b-col sm="5" md="4">
            <label>Complément 2</label>
            <b-input
              :value="newBuildingOwner.complement2"
              @input="updateNewBuildingOwner('complement2', $event)"
            />
          </b-col>
        </b-row>
        <!-- contact type -->
        <b-row class="mb-4 mx-sm-0">
          <b-col sm="6" md="5">
            <label>{{ $t("general.Type_d_envoi_prefere") }}</label>
            <ValidationProvider
              ref="vee-b-owner-contact_type"
              v-slot="{ errors, classes }"
              :name="'type d’envoi préféré'"
              rules="required"
            >
              <b-form-select
                :value="newBuildingOwner.contact_type"
                :options="contactTypeOptions"
                @change="updateNewBuildingOwner('contact_type', $event)"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BuildingOwnerMW from "@/middlewares/BuildingOwner";

import {
  departBuildingLotNewOwnerTypeOptions,
  departBuildingLotNewOwnerTypes,
} from "@/constants/building.js";

export default {
  props: {
    newOwnerType: {
      type: Number,
      default: 0,
    },

    existingBuildingOwnerId: {
      type: String,
      default: "",
    },
    newBuildingOwner: {
      type: Object,
      default: () => {
        return {};
      },
    },

    buildingOwnerId: {
      type: String,
      default: "",
    },
    buildingId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      departBuildingLotNewOwnerTypeOptions,
      departBuildingLotNewOwnerTypes,
      allBuildingOwners: [],
    };
  },
  computed: {
    allCountries() {
      return this.$store.getters.getCountries;
    },
    countryOptions() {
      let result = [];
      this.allCountries.forEach(element => {
        result.push({
          value: element.countryCode,
          text: element.countryName,
        });
      });
      return result;
    },
    buildingOwnersOptions() {
      var bos = this.allBuildingOwners
        .filter(bo => bo.id != this.buildingOwnerId && bo.building_id == this.buildingId)
        .sort((a, b) => {
          const lastnameA = (a.lastname || "").toUpperCase();
          const lastnameB = (b.lastname || "").toUpperCase();
          if (lastnameA < lastnameB) return -1;
          if (lastnameA > lastnameB) return 1;
          return 0;
        });

      bos.forEach(bo => {
        bo.name = this.getPersonName({}, bo);
      });

      return bos;
    },
  },
  async created() {
    await this.fetchAllBuildingOwners();
  },
  methods: {
    async fetchAllBuildingOwners() {
      try {
        const res = await BuildingOwnerMW.FETCH(this.buildingId);
        if (res && res.response && res.response.data) {
          this.allBuildingOwners = res.response.data["hydra:member"] || [];
        }
      } catch (err) {
        console.error("Error fetching building owners:", err);
        this.allBuildingOwners = [];
      }
    },
    updateNewOwnerType(value) {
      this.$emit("updateNewOwnerType", value);
    },
    updateExistingBuildingOwnerId(value) {
      this.$emit("updateExistingBuildingOwnerId", value);
    },
    updateNewBuildingOwner(key, value) {
      this.$emit("updateNewBuildingOwner", key, value);
    },
    setEntityType(type) {
      this.$emit("updateNewBuildingOwner", "entity_type", type);
      if (type == this.entityTypes.legal) {
        this.$emit("updateNewBuildingOwner", "gender", 0);
      }
    },
  },
};
</script>
